import React from "react";

import Modal from "../Modal";
import PixelFire from "./PixelFire";
import { trackAmplitudeEvent } from "../../amplitude";

export default class StreakSaveEarnedModal extends React.Component {
  componentDidMount() {
    trackAmplitudeEvent("streak_save_earned_viewed", {
      total_saves_balance: this.props.streakSaveBalance,
      current_streak_length: this.props.currentStreakDays,
      is_first_streak_save: false,
    });
    if (this.props.ackUrl) {
      $.ajax({ url: this.props.ackUrl, method: "POST", data: { type: "earn" } });
    }
  }

  onAwesomeClick() {
    trackAmplitudeEvent("streak_save_modal_tapped", { screen_type: "earned" });
    this.modal.hide();
  }

  render() {
    return (
      <Modal
        id="streak-save-earned-modal"
        ref={(el) => this.modal = el}
        size="small"
        title="Streak Save"
        onHidden={this.props.onHidden}
      >
        <div className="text-center" style={{ padding: "8px 12px 4px" }}>
          <div style={{ marginBottom: 16, display: "flex", justifyContent: "center" }}><PixelFire size={72} /></div>
          <h4 className="joystix" style={{ color: "#337ab7", marginTop: 0, marginBottom: 12 }}>+1 Streak Save</h4>
          <p style={{ color: "#5a5a5a", marginBottom: 28 }}>
            Your hard work is paying off. You've earned a day off—use it whenever you need a breather without losing your progress.
          </p>
          <button className="btn btn-success btn-block joystix btn-lg" onClick={() => this.onAwesomeClick()}>
            Awesome!
          </button>
        </div>
      </Modal>
    );
  }
}
